import BookmarkToggle from './bookmark-toggle';

const bookmarkToggleConfig = {
  name: 'bookmarkToggle',
  class: BookmarkToggle,
  querySelector: {},
  querySelectorAll: {},
  options: {},
};

export default bookmarkToggleConfig;
